import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResetPasswordComponent, ResetPasswordComponentService } from '@spartacus/user/profile/components';
import { SpinnerComponent, FormErrorsComponent } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-kn-br-reset-password',
    templateUrl: './kn-br-reset-password.component.html',
    styleUrls: ['./kn-br-reset-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpinnerComponent, ReactiveFormsModule, FormErrorsComponent, AsyncPipe, TranslatePipe]
})
export class KnBrResetPasswordComponent extends ResetPasswordComponent {
  constructor(protected service: ResetPasswordComponentService) {
    super(service);
  }
}
